import { Breadcrumbs, makeStyles } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import React from 'react';
import withBreadcrumbs from "react-router-breadcrumbs-hoc";
import { Link } from "react-router-dom";
import BreadcrumbBarProps from './BreadcrumbBarProps';

const useStyles = makeStyles((theme) => ({
    breadcrumbs: {
        paddingBottom: 15
    }
}));

export default function BreadcrumbBar(props: BreadcrumbBarProps) {

    const classes = useStyles();

    const BreadcrumbLinks = withBreadcrumbs(props.routes)(({ breadcrumbs }) => (
        <Breadcrumbs className={classes.breadcrumbs} separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {JSON.stringify(props.routes)}
            {breadcrumbs.map(({
                match,
                breadcrumb
            }) => (
                    <Link color="inherit" to={match.path}>
                        {breadcrumb}
                    </Link>
                ))}
        </Breadcrumbs>
    ));

    return (
        <React.Fragment>
            <BreadcrumbLinks />
        </React.Fragment>
    );
}